import { motion } from "motion/react";

import teamImage from "../assets/TeamPhoto.jpeg";

import { useReducedMotion } from "./ui/use-reduced-motion";

export default function AboutHero() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="relative flex w-full items-start justify-center px-4 pt-16 pb-6 md:min-h-screen md:items-center md:px-8 md:pt-40 md:pb-16 lg:px-16 lg:pt-32 lg:pb-32">
      <div className="mx-auto w-full max-w-[1600px]">
        <motion.div
          initial={prefersReducedMotion ? {} : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={
            prefersReducedMotion
              ? { duration: 0 }
              : { duration: 0.8, ease: "easeOut" }
          }
          className="space-y-3 text-center md:space-y-6"
        >
          <h1
            className="tracking-tight text-white"
            style={{
              //fontSize: "var(--text-display)",
              fontSize: "clamp(2.5rem, 8vw, 6rem)",
              fontWeight: "600",
              lineHeight: "clamp(1.05, 1vw, 0.95)",
            }}
          >
            Where design finds flow
          </h1>

          <p
            className="mx-auto max-w-3xl leading-relaxed text-gray-300"
            style={{ fontSize: "var(--text-lead)" }}
          >
            We're a team obsessed with craft, speed, and the future of product
            design.
          </p>

          <motion.div
            initial={prefersReducedMotion ? {} : { opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={
              prefersReducedMotion
                ? { duration: 0 }
                : { duration: 0.8, delay: 0.2, ease: "easeOut" }
            }
            className="pt-6 md:pt-4"
          >
            <img
              src={teamImage}
              alt="Flowstep team"
              className="h-auto w-full rounded-3xl shadow-xl md:shadow-2xl"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
